var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 15,
    r: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 15,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 15,
    y: 15,
    fill: "#DC143C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.b9c4bc383e77037d39c7dd558a1eb5d0.svg";
export { ForwardRef as ReactComponent };